<template>
  <div class="flex overview-container">
    <div class="flex align-center justify-center flex-column left-container">
      <div class="list-group-item row">
        <div class="col-lg-6 col-md-6 mt-35">
          <strong>Participants Completed: </strong>
        </div>
        <div class="col-lg-5 col-md-5 mt-35">
          <strong>{{ overviewData.participantCount }}</strong>
        </div>
      </div>
      <div class="list-group-item row">
        <div class="col-lg-6 col-md-6 mt-35">
          <strong>Average Time to Complete: </strong>
        </div>
        <div class="col-lg-5 col-md-5 mt-35">
          <strong>{{ avgTime }} </strong>
        </div>
      </div>
      <div class="list-group-item row">
        <div class="col-lg-6 col-md-6 mt-35">
          <strong>Average Overall Score:</strong>
        </div>
        <div class="col-lg-5 col-md-5 mt-35">
          <strong>{{ avgOverall }}</strong>
        </div>
      </div>
    </div>

    <div class="container">
      <table class="table table-condensed w-auto">
        <thead>
          <tr>
            <th scope="col" class="font-weight-normal">Skill name</th>
            <th scope="col" class="text-right">
              Average Score / <span class="font-weight-normal">Max Possible</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="({ skillName, averagePoints, maxPossible }, idx) in newSkillData">
            <tr :key="idx">
              <td>{{ skillName }}</td>
              <td class="text-right">
                <strong>{{ averagePoints }}</strong> / {{ maxPossible }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      versionKey: {
        type: Number,
        required: true,
        default: 0,
      },
      overviewData: {
        type: Object,
        default: () => {},
      },
      skillData: {
        type: Object,
        default: () => {},
      },
      skills: {
        type: Object,
        default: () => {},
      },
    },

    methods: {
      decimalCount(num) {
        const numToStr = num.toString();
        if (numToStr.includes('.')) return numToStr.split('.')[1].length;
        return 0;
      },
    },

    computed: {
      newSkillData() {
        return Object.values(this.skillData).reduce(
          (acc, { averagePoints, maxPossible, skillKey }) => {
            if (this.skills[skillKey]) {
              const skillName = this.skills[skillKey].name;
              const decimalCount = this.decimalCount(averagePoints);
              const newAveragePoints = decimalCount >= 2 ? averagePoints.toFixed(2) : averagePoints;
              acc[skillKey] = { skillName, averagePoints: newAveragePoints, maxPossible };
            }
            return acc;
          },
          {}
        );
      },
      avgTime() {
        const hours = Math.floor(this.overviewData.avgTime / 60);
        const minutes = this.overviewData.avgTime - hours * 60;
        return hours ? `${hours}h  ${minutes}m` : `${minutes}m`;
      },
      avgOverall() {
        const decimalCount = this.decimalCount(this.overviewData.avgOverall);
        return decimalCount >= 2
          ? this.overviewData.avgOverall.toFixed(2)
          : this.overviewData.avgOverall;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .overview-container {
    border: 1px solid #e3e3e3;
    height: 100%;
    .left-container {
      width: 40%;
    }

    .left-container > div {
      width: 100%;
      flex: 1;
      background-color: #f8f8f8;
    }

    & > :last-child {
      width: 60%;
    }
    .font-weight-normal {
      font-weight: normal;
    }
    .table {
      thead > tr > :last-child,
      tbody > tr > :last-child {
        padding-right: 100px;
      }
    }
  }
</style>
